import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useMembershipGlobalSettingTabs } from "./useMembershipGlobalSettingTabs";
import { SidebarTabs } from "@/components/Common/SidebarTabs";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { Page } from "@/pages/Page";

export const MembershipGlobalSettingsPage = () => {
    const history = useHistory();
    const { section } = useParams<{ id?: ID; section?: string }>();
    const tabs = useMembershipGlobalSettingTabs();

    const initialSection = section ?? tabs[0].id;
    const initialActiveIndex = tabs.findIndex((tab) => tab.id === section ?? initialSection);
    const [activeTabIndex, setActiveTabIndex] = useState(initialActiveIndex === -1 ? 0 : initialActiveIndex);

    useEffect(() => {
        if (initialActiveIndex > -1) {
            setActiveTabIndex(initialActiveIndex);
        }
    }, [initialActiveIndex]);

    const breadcrumbs: Array<{ label: string; url?: string }> = [
        { label: "Products", url: "/products/memberships" },
        { label: "Memberships", url: "/products/memberships" },
        { label: "Global Settings" },
        { label: tabs[activeTabIndex].label },
    ];

    const handleBreadcrumbClick = (index: number, url?: string) => {
        if (url) {
            history.push(url);
        }

        setActiveTabIndex(index);
    };

    const handleActiveTabChange = (index: number) => {
        history.push(`/products/memberships/globalSettings/${tabs[index].id}`);
    };

    return (
        <Page title="Global Settings">
            <ColumnLayout>
                <HeaderToolbar classNames="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        {breadcrumbs.map((breadcrumb) => (
                            <Breadcrumb.Item
                                key={breadcrumb.label}
                                onClick={() => handleBreadcrumbClick(0, breadcrumb.url)}
                            >
                                {breadcrumb.label}
                            </Breadcrumb.Item>
                        ))}
                    </HeaderToolbar.Breadcrumb>
                    <div id="header-toolbar-actions" />
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <SidebarTabs activeTab={activeTabIndex} onClick={handleActiveTabChange}>
                        {tabs.map((tab) => {
                            return (
                                <SidebarTabs.Tab
                                    key={tab.id}
                                    name={tab.label}
                                    icon={tab.icon}
                                    description={tab.description}
                                >
                                    {tab.content ?? "No Content"}
                                </SidebarTabs.Tab>
                            );
                        })}
                    </SidebarTabs>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
